import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";

import { convertFormApprovalDataToReviewStrategy } from "../../../CreateRequirementDefinitionForm/utils";

export const getReviewStrategyLabel = (
  payload: Parameters<typeof convertFormApprovalDataToReviewStrategy>[0]
): string => {
  const strategy = convertFormApprovalDataToReviewStrategy(payload);

  switch (strategy) {
    case RequirementReviewStrategy.AlwaysRequired:
      return "Always required";
    case RequirementReviewStrategy.OnFail:
      return "Required on fail";
    case RequirementReviewStrategy.NeverRequired:
      return "Not required";
    default:
      return "Not required";
  }
};
